import { t } from '../i18n';

/**
 * Google's "search suggestions", which its terms require to be shown with answers grounded on
 * Google Search (contracts/assist-function.md): exactly as Google supplies them, in a sandboxed
 * frame that runs no script and cannot reach the app; links open in a new tab.
 */
export function GoogleSearchSuggestions({ html }: { html: string }) {
  return (
    <iframe
      className="suggestions__google"
      title={t('suggest.searchSuggestions')}
      sandbox="allow-popups allow-popups-to-escape-sandbox"
      srcDoc={`<base target="_blank">${html}`}
    />
  );
}
